<div class="container-fluid">
 
    <app-navigation ></app-navigation>
    <div class="screen-container" (click)="closeuserProfile()">
    <alert></alert>
    <router-outlet></router-outlet>
 </div>
</div>